import { api } from '../configs/apiConfig';
import { toast } from 'react-toastify';

const userDocumentTypeService = {
    getAll: async () => {
        try {
            const response = await api.get('/UserDocumentType');
            return response.data;
        } catch (error) {
            toast.error('Failed to fetch document types');
            throw error;
        }
    },

    getActive: async () => {
        try {
            const response = await api.get('/UserDocumentType/active');
            return response.data;
        } catch (error) {
            toast.error('Failed to fetch active document types');
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/UserDocumentType/${id}`);
            return response.data;
        } catch (error) {
            toast.error('Failed to fetch document type');
            throw error;
        }
    },

    create: async (data) => {
        try {
            const response = await api.post('/UserDocumentType', data);
            toast.success('Document type created successfully');
            return response.data;
        } catch (error) {
            toast.error('Failed to create document type');
            throw error;
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.put(`/UserDocumentType/${id}`, data);
            toast.success('Document type updated successfully');
            return response.data;
        } catch (error) {
            toast.error('Failed to update document type');
            throw error;
        }
    },

    delete: async (id) => {
        try {
            await api.delete(`/UserDocumentType/${id}`);
            toast.success('Document type deleted successfully');
        } catch (error) {
            toast.error('Failed to delete document type');
            throw error;
        }
    },

    toggleStatus: async (id) => {
        try {
            const response = await api.post(`/UserDocumentType/${id}/toggle-status`);
            toast.success('Document type status updated successfully');
            return response.data;
        } catch (error) {
            toast.error('Failed to update document type status');
            throw error;
        }
    }
};

export default userDocumentTypeService; 